// This file is auto-generated by @hey-api/openapi-ts

import { type Client, type ClientMeta, formDataBodySerializer, type Options as Options2, type RequestResult, type ServerSentEventsResult, type TDataShape } from './client';
import { client } from './client.gen';
import type { AdminControllerCreateUserData, AdminControllerCreateUserResponses, AdminControllerGetLogsData, AdminControllerGetLogsResponses, AdminControllerGetMeData, AdminControllerGetMeResponses, AdminControllerGetUsersData, AdminControllerGetUsersResponses, AdminControllerUpdateUserData, AdminControllerUpdateUserResponses, BatchControllerUploadData, BatchControllerUploadResponses, BatchControllerValidateData, BatchControllerValidateResponses, CardsControllerCancelRenderData, CardsControllerCancelRenderResponses, CardsControllerCommitData, CardsControllerCommitResponses, CardsControllerDiscardPreflightData, CardsControllerDiscardPreflightResponses, CardsControllerDownloadData, CardsControllerDownloadResponses, CardsControllerGenerateFromIseeData, CardsControllerGenerateFromIseeResponses, CardsControllerGetJobsData, CardsControllerGetJobsResponses, CardsControllerHistoryData, CardsControllerHistoryDetailData, CardsControllerHistoryDetailResponses, CardsControllerHistoryDownloadData, CardsControllerHistoryDownloadResponses, CardsControllerHistoryResponses, CardsControllerPdfData, CardsControllerPdfResponses, CardsControllerPreflightCsvData, CardsControllerPreflightCsvResponses, CardsControllerPreflightLuccaData, CardsControllerPreflightLuccaResponses, CardsControllerPreviewData, CardsControllerPreviewResponses, CardsControllerPreviewsData, CardsControllerPreviewsResponses, CardsControllerRecapData, CardsControllerRecapResponses, CardsControllerStreamData, CardsControllerStreamResponse, CardsControllerStreamResponses, CardSideControllerCreateSideData, CardSideControllerCreateSideResponses, CardSideControllerDeleteSideData, CardSideControllerDeleteSideResponses, CardSideControllerGetSidesData, CardSideControllerGetSidesResponses, CardSideControllerGetSideSvgData, CardSideControllerGetSideSvgResponses, CardSideControllerRenameSideData, CardSideControllerRenameSideResponses, CardTemplateControllerCreateTemplateData, CardTemplateControllerCreateTemplateResponses, CardTemplateControllerDeleteTemplateData, CardTemplateControllerDeleteTemplateResponses, CardTemplateControllerGetAllTemplatesData, CardTemplateControllerGetAllTemplatesResponses, CardTemplateControllerGetTemplatesData, CardTemplateControllerGetTemplatesResponses, CardTemplateControllerGetTemplateSvgData, CardTemplateControllerGetTemplateSvgResponses, CardTemplateControllerGetTemplateSvgsData, CardTemplateControllerGetTemplateSvgsResponses, CardTemplateControllerUpdateTemplateData, CardTemplateControllerUpdateTemplateResponses, DashboardControllerGetData, DashboardControllerGetResponses, HealthControllerCheckData, HealthControllerCheckResponses, IseeControllerGetFieldsData, IseeControllerGetFieldsResponses, IseeControllerGetSessionsData, IseeControllerGetSessionsResponses, IseeControllerGetStatusData, IseeControllerGetStatusResponses, IseeControllerGetStudentsData, IseeControllerGetStudentsResponses, LuccaControllerGetFieldsData, LuccaControllerGetFieldsResponses, LuccaControllerGetStatusData, LuccaControllerGetStatusResponses, PhotosControllerExportPhotosData, PhotosControllerExportPhotosResponses, PhotosControllerGetPhotoUrlsData, PhotosControllerGetPhotoUrlsResponses, UsersControllerApprovePendingData, UsersControllerApprovePendingResponses, UsersControllerCancelOwnPendingData, UsersControllerCancelOwnPendingResponses, UsersControllerDeleteUserPhotoData, UsersControllerDeleteUserPhotoResponses, UsersControllerGetOwnPendingData, UsersControllerGetOwnPendingResponses, UsersControllerGetPendingByUserData, UsersControllerGetPendingByUserResponses, UsersControllerGetUserData, UsersControllerGetUserPhotoData, UsersControllerGetUserPhotoResponses, UsersControllerGetUserResponses, UsersControllerListPendingData, UsersControllerListPendingResponses, UsersControllerRejectPendingData, UsersControllerRejectPendingResponses, UsersControllerSearchUsersData, UsersControllerSearchUsersResponses, UsersControllerTriggerSweepData, UsersControllerTriggerSweepResponses, UsersControllerUploadUserPhotoData, UsersControllerUploadUserPhotoResponses } from './types.gen';
import { zAdminControllerCreateUserResponse, zAdminControllerGetLogsResponse, zAdminControllerGetMeResponse, zAdminControllerGetUsersResponse, zAdminControllerUpdateUserResponse, zBatchControllerUploadResponse, zBatchControllerValidateResponse, zCardsControllerCancelRenderResponse, zCardsControllerCommitResponse, zCardsControllerDiscardPreflightResponse, zCardsControllerDownloadResponse, zCardsControllerGenerateFromIseeResponse, zCardsControllerGetJobsResponse, zCardsControllerHistoryDetailResponse, zCardsControllerHistoryDownloadResponse, zCardsControllerHistoryResponse, zCardsControllerPdfResponse, zCardsControllerPreflightCsvResponse, zCardsControllerPreflightLuccaResponse, zCardsControllerPreviewResponse, zCardsControllerPreviewsResponse, zCardsControllerRecapResponse, zCardsControllerStreamResponse, zCardSideControllerCreateSideResponse, zCardSideControllerDeleteSideResponse, zCardSideControllerGetSidesResponse, zCardSideControllerGetSideSvgResponse, zCardSideControllerRenameSideResponse, zCardTemplateControllerCreateTemplateResponse, zCardTemplateControllerDeleteTemplateResponse, zCardTemplateControllerGetAllTemplatesResponse, zCardTemplateControllerGetTemplatesResponse, zCardTemplateControllerGetTemplateSvgResponse, zCardTemplateControllerGetTemplateSvgsResponse, zCardTemplateControllerUpdateTemplateResponse, zDashboardControllerGetResponse, zHealthControllerCheckResponse, zIseeControllerGetFieldsResponse, zIseeControllerGetSessionsResponse, zIseeControllerGetStatusResponse, zIseeControllerGetStudentsResponse, zLuccaControllerGetFieldsResponse, zLuccaControllerGetStatusResponse, zPhotosControllerExportPhotosResponse, zPhotosControllerGetPhotoUrlsResponse, zUsersControllerApprovePendingResponse, zUsersControllerCancelOwnPendingResponse, zUsersControllerDeleteUserPhotoResponse, zUsersControllerGetOwnPendingResponse, zUsersControllerGetPendingByUserResponse, zUsersControllerGetUserPhotoResponse, zUsersControllerGetUserResponse, zUsersControllerListPendingResponse, zUsersControllerRejectPendingResponse, zUsersControllerSearchUsersResponse, zUsersControllerTriggerSweepResponse, zUsersControllerUploadUserPhotoResponse } from './zod.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

export const healthControllerCheck = <ThrowOnError extends boolean = false>(options?: Options<HealthControllerCheckData, ThrowOnError>): RequestResult<HealthControllerCheckResponses, unknown, ThrowOnError> => (options?.client ?? client).get<HealthControllerCheckResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zHealthControllerCheckResponse.parseAsync(data),
    url: '/health',
    ...options
});

export const usersControllerSearchUsers = <ThrowOnError extends boolean = false>(options: Options<UsersControllerSearchUsersData, ThrowOnError>): RequestResult<UsersControllerSearchUsersResponses, unknown, ThrowOnError> => (options.client ?? client).get<UsersControllerSearchUsersResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zUsersControllerSearchUsersResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users/search',
    ...options
});

export const usersControllerDeleteUserPhoto = <ThrowOnError extends boolean = false>(options: Options<UsersControllerDeleteUserPhotoData, ThrowOnError>): RequestResult<UsersControllerDeleteUserPhotoResponses, unknown, ThrowOnError> => (options.client ?? client).delete<UsersControllerDeleteUserPhotoResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zUsersControllerDeleteUserPhotoResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users/{userId}/photo',
    ...options
});

export const usersControllerGetUserPhoto = <ThrowOnError extends boolean = false>(options: Options<UsersControllerGetUserPhotoData, ThrowOnError>): RequestResult<UsersControllerGetUserPhotoResponses, unknown, ThrowOnError> => (options.client ?? client).get<UsersControllerGetUserPhotoResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zUsersControllerGetUserPhotoResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users/{userId}/photo',
    ...options
});

export const usersControllerUploadUserPhoto = <ThrowOnError extends boolean = false>(options: Options<UsersControllerUploadUserPhotoData, ThrowOnError>): RequestResult<UsersControllerUploadUserPhotoResponses, unknown, ThrowOnError> => (options.client ?? client).post<UsersControllerUploadUserPhotoResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    responseValidator: async (data) => await zUsersControllerUploadUserPhotoResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users/{userId}/photo',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

export const usersControllerCancelOwnPending = <ThrowOnError extends boolean = false>(options?: Options<UsersControllerCancelOwnPendingData, ThrowOnError>): RequestResult<UsersControllerCancelOwnPendingResponses, unknown, ThrowOnError> => (options?.client ?? client).delete<UsersControllerCancelOwnPendingResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zUsersControllerCancelOwnPendingResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users/me/pending',
    ...options
});

export const usersControllerGetOwnPending = <ThrowOnError extends boolean = false>(options?: Options<UsersControllerGetOwnPendingData, ThrowOnError>): RequestResult<UsersControllerGetOwnPendingResponses, unknown, ThrowOnError> => (options?.client ?? client).get<UsersControllerGetOwnPendingResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zUsersControllerGetOwnPendingResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users/me/pending',
    ...options
});

export const usersControllerListPending = <ThrowOnError extends boolean = false>(options?: Options<UsersControllerListPendingData, ThrowOnError>): RequestResult<UsersControllerListPendingResponses, unknown, ThrowOnError> => (options?.client ?? client).get<UsersControllerListPendingResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zUsersControllerListPendingResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users/pending',
    ...options
});

export const usersControllerGetPendingByUser = <ThrowOnError extends boolean = false>(options: Options<UsersControllerGetPendingByUserData, ThrowOnError>): RequestResult<UsersControllerGetPendingByUserResponses, unknown, ThrowOnError> => (options.client ?? client).get<UsersControllerGetPendingByUserResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zUsersControllerGetPendingByUserResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users/{userId}/pending',
    ...options
});

export const usersControllerApprovePending = <ThrowOnError extends boolean = false>(options: Options<UsersControllerApprovePendingData, ThrowOnError>): RequestResult<UsersControllerApprovePendingResponses, unknown, ThrowOnError> => (options.client ?? client).post<UsersControllerApprovePendingResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zUsersControllerApprovePendingResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users/pending/{id}/approve',
    ...options
});

export const usersControllerTriggerSweep = <ThrowOnError extends boolean = false>(options?: Options<UsersControllerTriggerSweepData, ThrowOnError>): RequestResult<UsersControllerTriggerSweepResponses, unknown, ThrowOnError> => (options?.client ?? client).post<UsersControllerTriggerSweepResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zUsersControllerTriggerSweepResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users/pending/sweep',
    ...options
});

export const usersControllerRejectPending = <ThrowOnError extends boolean = false>(options: Options<UsersControllerRejectPendingData, ThrowOnError>): RequestResult<UsersControllerRejectPendingResponses, unknown, ThrowOnError> => (options.client ?? client).post<UsersControllerRejectPendingResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zUsersControllerRejectPendingResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users/pending/{id}/reject',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const usersControllerGetUser = <ThrowOnError extends boolean = false>(options: Options<UsersControllerGetUserData, ThrowOnError>): RequestResult<UsersControllerGetUserResponses, unknown, ThrowOnError> => (options.client ?? client).get<UsersControllerGetUserResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zUsersControllerGetUserResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users/{userId}',
    ...options
});

export const luccaControllerGetStatus = <ThrowOnError extends boolean = false>(options?: Options<LuccaControllerGetStatusData, ThrowOnError>): RequestResult<LuccaControllerGetStatusResponses, unknown, ThrowOnError> => (options?.client ?? client).get<LuccaControllerGetStatusResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zLuccaControllerGetStatusResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/lucca/status',
    ...options
});

export const luccaControllerGetFields = <ThrowOnError extends boolean = false>(options?: Options<LuccaControllerGetFieldsData, ThrowOnError>): RequestResult<LuccaControllerGetFieldsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<LuccaControllerGetFieldsResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zLuccaControllerGetFieldsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/lucca/fields',
    ...options
});

export const photosControllerExportPhotos = <ThrowOnError extends boolean = false>(options: Options<PhotosControllerExportPhotosData, ThrowOnError>): RequestResult<PhotosControllerExportPhotosResponses, unknown, ThrowOnError> => (options.client ?? client).get<PhotosControllerExportPhotosResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zPhotosControllerExportPhotosResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/photos/export',
    ...options
});

export const photosControllerGetPhotoUrls = <ThrowOnError extends boolean = false>(options: Options<PhotosControllerGetPhotoUrlsData, ThrowOnError>): RequestResult<PhotosControllerGetPhotoUrlsResponses, unknown, ThrowOnError> => (options.client ?? client).post<PhotosControllerGetPhotoUrlsResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zPhotosControllerGetPhotoUrlsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/photos/urls',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const iseeControllerGetStatus = <ThrowOnError extends boolean = false>(options?: Options<IseeControllerGetStatusData, ThrowOnError>): RequestResult<IseeControllerGetStatusResponses, unknown, ThrowOnError> => (options?.client ?? client).get<IseeControllerGetStatusResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zIseeControllerGetStatusResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/isee/status',
    ...options
});

export const iseeControllerGetFields = <ThrowOnError extends boolean = false>(options?: Options<IseeControllerGetFieldsData, ThrowOnError>): RequestResult<IseeControllerGetFieldsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<IseeControllerGetFieldsResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zIseeControllerGetFieldsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/isee/fields',
    ...options
});

export const iseeControllerGetSessions = <ThrowOnError extends boolean = false>(options?: Options<IseeControllerGetSessionsData, ThrowOnError>): RequestResult<IseeControllerGetSessionsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<IseeControllerGetSessionsResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zIseeControllerGetSessionsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/isee/sessions',
    ...options
});

export const iseeControllerGetStudents = <ThrowOnError extends boolean = false>(options: Options<IseeControllerGetStudentsData, ThrowOnError>): RequestResult<IseeControllerGetStudentsResponses, unknown, ThrowOnError> => (options.client ?? client).get<IseeControllerGetStudentsResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zIseeControllerGetStudentsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/isee/students',
    ...options
});

export const batchControllerValidate = <ThrowOnError extends boolean = false>(options: Options<BatchControllerValidateData, ThrowOnError>): RequestResult<BatchControllerValidateResponses, unknown, ThrowOnError> => (options.client ?? client).post<BatchControllerValidateResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zBatchControllerValidateResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/batch/validate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const batchControllerUpload = <ThrowOnError extends boolean = false>(options: Options<BatchControllerUploadData, ThrowOnError>): RequestResult<BatchControllerUploadResponses, unknown, ThrowOnError> => (options.client ?? client).post<BatchControllerUploadResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    responseValidator: async (data) => await zBatchControllerUploadResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/batch/upload',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

export const cardsControllerPreflightCsv = <ThrowOnError extends boolean = false>(options: Options<CardsControllerPreflightCsvData, ThrowOnError>): RequestResult<CardsControllerPreflightCsvResponses, unknown, ThrowOnError> => (options.client ?? client).post<CardsControllerPreflightCsvResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    responseValidator: async (data) => await zCardsControllerPreflightCsvResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/cards/preflight',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

export const cardsControllerGenerateFromIsee = <ThrowOnError extends boolean = false>(options: Options<CardsControllerGenerateFromIseeData, ThrowOnError>): RequestResult<CardsControllerGenerateFromIseeResponses, unknown, ThrowOnError> => (options.client ?? client).post<CardsControllerGenerateFromIseeResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    responseValidator: async (data) => await zCardsControllerGenerateFromIseeResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/cards/preflight/isee',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

export const cardsControllerPreflightLucca = <ThrowOnError extends boolean = false>(options: Options<CardsControllerPreflightLuccaData, ThrowOnError>): RequestResult<CardsControllerPreflightLuccaResponses, unknown, ThrowOnError> => (options.client ?? client).post<CardsControllerPreflightLuccaResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zCardsControllerPreflightLuccaResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/cards/preflight/lucca',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const cardsControllerRecap = <ThrowOnError extends boolean = false>(options: Options<CardsControllerRecapData, ThrowOnError>): RequestResult<CardsControllerRecapResponses, unknown, ThrowOnError> => (options.client ?? client).get<CardsControllerRecapResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zCardsControllerRecapResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/cards/preflight/{id}/recap',
    ...options
});

export const cardsControllerDiscardPreflight = <ThrowOnError extends boolean = false>(options: Options<CardsControllerDiscardPreflightData, ThrowOnError>): RequestResult<CardsControllerDiscardPreflightResponses, unknown, ThrowOnError> => (options.client ?? client).delete<CardsControllerDiscardPreflightResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zCardsControllerDiscardPreflightResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/cards/preflight/{id}',
    ...options
});

export const cardsControllerCancelRender = <ThrowOnError extends boolean = false>(options: Options<CardsControllerCancelRenderData, ThrowOnError>): RequestResult<CardsControllerCancelRenderResponses, unknown, ThrowOnError> => (options.client ?? client).delete<CardsControllerCancelRenderResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zCardsControllerCancelRenderResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/cards/render/{jobId}',
    ...options
});

export const cardsControllerCommit = <ThrowOnError extends boolean = false>(options: Options<CardsControllerCommitData, ThrowOnError>): RequestResult<CardsControllerCommitResponses, unknown, ThrowOnError> => (options.client ?? client).post<CardsControllerCommitResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zCardsControllerCommitResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/cards/commit',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const cardsControllerGetJobs = <ThrowOnError extends boolean = false>(options?: Options<CardsControllerGetJobsData, ThrowOnError>): RequestResult<CardsControllerGetJobsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<CardsControllerGetJobsResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zCardsControllerGetJobsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/cards/jobs',
    ...options
});

export const cardsControllerStream = <ThrowOnError extends boolean = false>(options: Options<CardsControllerStreamData, ThrowOnError, CardsControllerStreamResponse>): Promise<ServerSentEventsResult<CardsControllerStreamResponses>> => (options.client ?? client).sse.get<CardsControllerStreamResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zCardsControllerStreamResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/cards/stream/{jobId}',
    ...options
});

export const cardsControllerPreview = <ThrowOnError extends boolean = false>(options: Options<CardsControllerPreviewData, ThrowOnError>): RequestResult<CardsControllerPreviewResponses, unknown, ThrowOnError> => (options.client ?? client).get<CardsControllerPreviewResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zCardsControllerPreviewResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/cards/{jobId}/preview/{upn}',
    ...options
});

export const cardsControllerPreviews = <ThrowOnError extends boolean = false>(options: Options<CardsControllerPreviewsData, ThrowOnError>): RequestResult<CardsControllerPreviewsResponses, unknown, ThrowOnError> => (options.client ?? client).get<CardsControllerPreviewsResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zCardsControllerPreviewsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/cards/{jobId}/previews',
    ...options
});

export const cardsControllerDownload = <ThrowOnError extends boolean = false>(options: Options<CardsControllerDownloadData, ThrowOnError>): RequestResult<CardsControllerDownloadResponses, unknown, ThrowOnError> => (options.client ?? client).get<CardsControllerDownloadResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zCardsControllerDownloadResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/cards/download/{jobId}',
    ...options
});

export const cardsControllerPdf = <ThrowOnError extends boolean = false>(options: Options<CardsControllerPdfData, ThrowOnError>): RequestResult<CardsControllerPdfResponses, unknown, ThrowOnError> => (options.client ?? client).get<CardsControllerPdfResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zCardsControllerPdfResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/cards/pdf/{jobId}',
    ...options
});

export const cardsControllerHistory = <ThrowOnError extends boolean = false>(options?: Options<CardsControllerHistoryData, ThrowOnError>): RequestResult<CardsControllerHistoryResponses, unknown, ThrowOnError> => (options?.client ?? client).get<CardsControllerHistoryResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zCardsControllerHistoryResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/cards/history',
    ...options
});

export const cardsControllerHistoryDetail = <ThrowOnError extends boolean = false>(options: Options<CardsControllerHistoryDetailData, ThrowOnError>): RequestResult<CardsControllerHistoryDetailResponses, unknown, ThrowOnError> => (options.client ?? client).get<CardsControllerHistoryDetailResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zCardsControllerHistoryDetailResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/cards/history/{batchId}',
    ...options
});

export const cardsControllerHistoryDownload = <ThrowOnError extends boolean = false>(options: Options<CardsControllerHistoryDownloadData, ThrowOnError>): RequestResult<CardsControllerHistoryDownloadResponses, unknown, ThrowOnError> => (options.client ?? client).get<CardsControllerHistoryDownloadResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zCardsControllerHistoryDownloadResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/cards/history/{batchId}/download',
    ...options
});

export const adminControllerGetMe = <ThrowOnError extends boolean = false>(options?: Options<AdminControllerGetMeData, ThrowOnError>): RequestResult<AdminControllerGetMeResponses, unknown, ThrowOnError> => (options?.client ?? client).get<AdminControllerGetMeResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zAdminControllerGetMeResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/me',
    ...options
});

export const adminControllerGetUsers = <ThrowOnError extends boolean = false>(options?: Options<AdminControllerGetUsersData, ThrowOnError>): RequestResult<AdminControllerGetUsersResponses, unknown, ThrowOnError> => (options?.client ?? client).get<AdminControllerGetUsersResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zAdminControllerGetUsersResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/users',
    ...options
});

export const adminControllerCreateUser = <ThrowOnError extends boolean = false>(options: Options<AdminControllerCreateUserData, ThrowOnError>): RequestResult<AdminControllerCreateUserResponses, unknown, ThrowOnError> => (options.client ?? client).post<AdminControllerCreateUserResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zAdminControllerCreateUserResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/users',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const adminControllerUpdateUser = <ThrowOnError extends boolean = false>(options: Options<AdminControllerUpdateUserData, ThrowOnError>): RequestResult<AdminControllerUpdateUserResponses, unknown, ThrowOnError> => (options.client ?? client).patch<AdminControllerUpdateUserResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zAdminControllerUpdateUserResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/users/{oid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const adminControllerGetLogs = <ThrowOnError extends boolean = false>(options?: Options<AdminControllerGetLogsData, ThrowOnError>): RequestResult<AdminControllerGetLogsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<AdminControllerGetLogsResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zAdminControllerGetLogsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/logs',
    ...options
});

export const cardSideControllerGetSides = <ThrowOnError extends boolean = false>(options?: Options<CardSideControllerGetSidesData, ThrowOnError>): RequestResult<CardSideControllerGetSidesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<CardSideControllerGetSidesResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zCardSideControllerGetSidesResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/sides',
    ...options
});

export const cardSideControllerCreateSide = <ThrowOnError extends boolean = false>(options: Options<CardSideControllerCreateSideData, ThrowOnError>): RequestResult<CardSideControllerCreateSideResponses, unknown, ThrowOnError> => (options.client ?? client).post<CardSideControllerCreateSideResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    responseValidator: async (data) => await zCardSideControllerCreateSideResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/sides',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

export const cardSideControllerGetSideSvg = <ThrowOnError extends boolean = false>(options: Options<CardSideControllerGetSideSvgData, ThrowOnError>): RequestResult<CardSideControllerGetSideSvgResponses, unknown, ThrowOnError> => (options.client ?? client).get<CardSideControllerGetSideSvgResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zCardSideControllerGetSideSvgResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/sides/{id}/svg',
    ...options
});

export const cardSideControllerDeleteSide = <ThrowOnError extends boolean = false>(options: Options<CardSideControllerDeleteSideData, ThrowOnError>): RequestResult<CardSideControllerDeleteSideResponses, unknown, ThrowOnError> => (options.client ?? client).delete<CardSideControllerDeleteSideResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zCardSideControllerDeleteSideResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/sides/{id}',
    ...options
});

export const cardSideControllerRenameSide = <ThrowOnError extends boolean = false>(options: Options<CardSideControllerRenameSideData, ThrowOnError>): RequestResult<CardSideControllerRenameSideResponses, unknown, ThrowOnError> => (options.client ?? client).patch<CardSideControllerRenameSideResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zCardSideControllerRenameSideResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/sides/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const cardTemplateControllerGetTemplates = <ThrowOnError extends boolean = false>(options?: Options<CardTemplateControllerGetTemplatesData, ThrowOnError>): RequestResult<CardTemplateControllerGetTemplatesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<CardTemplateControllerGetTemplatesResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zCardTemplateControllerGetTemplatesResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/templates',
    ...options
});

export const cardTemplateControllerCreateTemplate = <ThrowOnError extends boolean = false>(options: Options<CardTemplateControllerCreateTemplateData, ThrowOnError>): RequestResult<CardTemplateControllerCreateTemplateResponses, unknown, ThrowOnError> => (options.client ?? client).post<CardTemplateControllerCreateTemplateResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zCardTemplateControllerCreateTemplateResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/templates',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const cardTemplateControllerGetAllTemplates = <ThrowOnError extends boolean = false>(options?: Options<CardTemplateControllerGetAllTemplatesData, ThrowOnError>): RequestResult<CardTemplateControllerGetAllTemplatesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<CardTemplateControllerGetAllTemplatesResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zCardTemplateControllerGetAllTemplatesResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/templates/all',
    ...options
});

export const cardTemplateControllerGetTemplateSvg = <ThrowOnError extends boolean = false>(options: Options<CardTemplateControllerGetTemplateSvgData, ThrowOnError>): RequestResult<CardTemplateControllerGetTemplateSvgResponses, unknown, ThrowOnError> => (options.client ?? client).get<CardTemplateControllerGetTemplateSvgResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zCardTemplateControllerGetTemplateSvgResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/templates/{id}/svg',
    ...options
});

export const cardTemplateControllerGetTemplateSvgs = <ThrowOnError extends boolean = false>(options: Options<CardTemplateControllerGetTemplateSvgsData, ThrowOnError>): RequestResult<CardTemplateControllerGetTemplateSvgsResponses, unknown, ThrowOnError> => (options.client ?? client).get<CardTemplateControllerGetTemplateSvgsResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zCardTemplateControllerGetTemplateSvgsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/templates/{id}/svgs',
    ...options
});

export const cardTemplateControllerDeleteTemplate = <ThrowOnError extends boolean = false>(options: Options<CardTemplateControllerDeleteTemplateData, ThrowOnError>): RequestResult<CardTemplateControllerDeleteTemplateResponses, unknown, ThrowOnError> => (options.client ?? client).delete<CardTemplateControllerDeleteTemplateResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zCardTemplateControllerDeleteTemplateResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/templates/{id}',
    ...options
});

export const cardTemplateControllerUpdateTemplate = <ThrowOnError extends boolean = false>(options: Options<CardTemplateControllerUpdateTemplateData, ThrowOnError>): RequestResult<CardTemplateControllerUpdateTemplateResponses, unknown, ThrowOnError> => (options.client ?? client).patch<CardTemplateControllerUpdateTemplateResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zCardTemplateControllerUpdateTemplateResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/templates/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const dashboardControllerGet = <ThrowOnError extends boolean = false>(options?: Options<DashboardControllerGetData, ThrowOnError>): RequestResult<DashboardControllerGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<DashboardControllerGetResponses, unknown, ThrowOnError>({
    responseValidator: async (data) => await zDashboardControllerGetResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/dashboard',
    ...options
});
